import React from 'react';

const DisplayNameMismatchModal = ({ email, existingDisplayName, onClose, onUseExistingName }) => {
  const handleUseExistingName = () => {
    onUseExistingName(existingDisplayName);
    onClose();
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.6)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10002,
      animation: 'fadeIn 0.2s ease-in'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '2rem',
        maxWidth: '500px',
        width: '90%',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)'
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <div style={{
            fontSize: '3rem',
            color: '#ffc107',
            marginBottom: '1rem'
          }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16" style={{ display: 'block', margin: '0 auto' }}>
              <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
            </svg>
          </div>
          <h2 style={{ margin: 0, color: '#333', fontSize: '1.5rem' }}>
            Display Name Mismatch
          </h2>
        </div>

        {/* Message */}
        <div style={{ marginBottom: '1.5rem' }}>
          <p style={{ margin: '0 0 1rem 0', color: '#495057', textAlign: 'center' }}>
            This email already exists as a user with a different display name.
          </p>
          <p style={{ margin: '0 0 1rem 0', color: '#495057', textAlign: 'center' }}>
            <strong>Email:</strong> {email}
          </p>
        </div>

        {/* Existing Display Name Box */}
        <div style={{
          background: '#f8f9fa',
          border: '2px solid #007bff',
          borderRadius: '8px',
          padding: '1rem',
          marginBottom: '1.5rem'
        }}>
          <label style={{ 
            display: 'block', 
            marginBottom: '0.5rem', 
            fontWeight: '600', 
            color: '#495057',
            fontSize: '0.9rem'
          }}>
            Existing Display Name:
          </label>
          <div style={{
            padding: '0.75rem',
            background: 'white',
            border: '1px solid #ced4da',
            borderRadius: '6px',
            fontSize: '1rem',
            fontWeight: '600',
            color: '#007bff',
            textAlign: 'center'
          }}>
            {existingDisplayName}
          </div>
        </div>

        {/* Info Box */}
        <div style={{
          background: '#fff3cd',
          border: '1px solid #ffeaa7',
          borderRadius: '6px',
          padding: '1rem',
          marginBottom: '1.5rem'
        }}>
          <p style={{ margin: 0, fontSize: '0.9rem', color: '#856404' }}>
            <strong>Note:</strong> Click "Use Existing Name & Continue" to add this user as an administrator with the correct display name.
          </p>
        </div>

        {/* Action Buttons */}
        <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            className="btn btn-secondary"
          >
            Cancel
          </button>
          <button
            onClick={handleUseExistingName}
            className="btn btn-primary"
          >
            Use Existing Name & Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisplayNameMismatchModal;
